import UpdateMarkerModel from "@/domain/marker/UpdateMarkerModel";
import DualloMarkerClient from "@/clients/duallo/DualloMarkerClient";

class MarkerService {

    async CreateNewMarker(newMarker){
        return await DualloMarkerClient.createMarker(newMarker)
    }

    async UpdateMarker(modifiedMarker){        
        const request = new UpdateMarkerModel(modifiedMarker.id, modifiedMarker.assetId, modifiedMarker.transform, modifiedMarker.status, modifiedMarker.inspectionAreaId, modifiedMarker.eTag, modifiedMarker.scanId);
        return await DualloMarkerClient.updateMarker(request);
    }

    async UpdateMarkerStatus(modifiedMarker){
        return await DualloMarkerClient.updateMarkerStatus(modifiedMarker);
    }

    // Replace the marker's whole set of assigned org-level tags. Returns the refreshed AnomalyMarker.
    async AssignTags(scanId, markerId, tagIds){
        return await DualloMarkerClient.assignMarkerTags(scanId, markerId, tagIds ?? []);
    }

    async GetByIdAsync(assetId, markerId){
        return await DualloMarkerClient.getById(assetId, markerId);
    }

    async UploadThumbnail(updateRequest){
        return await DualloMarkerClient.updateMarkerThumbnail(updateRequest);
    }
    
    async deleteMarker(marker){
        marker.isActive = false;
        return await DualloMarkerClient.deleteMarker(marker);
    }


    // COMMENTS //
    async createMarkerComment(newComment){
        return await DualloMarkerClient.createMarkerComment(newComment);
    }

    async getCommentByMarkerIdAsync(markerId){
        return await DualloMarkerClient.getCommentsByMarkerId(markerId);
    }


    // CATEGORIES //
    async CreateMarkerType(newCategory){
        return await DualloMarkerClient.createMarkerType(newCategory);
    }

    async getMarkerTypesByOrganizationId(organizationId){
        return await DualloMarkerClient.getMarkerTypesByOrganizationId(organizationId);
    }

    async updateMarkerType(modifiedCategory){
        return await DualloMarkerClient.updateMarkerType(modifiedCategory);
    }


    // EVENTS //
    async getEventsByMarkerIdAsync(markerId){
        return await DualloMarkerClient.getEventsByMarkerId(markerId);
    }
}

export default new MarkerService();